// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aabb56c9","455":"d7b4228e","977":"055f381f"}[chunkId] + ".chunk.js";
};